import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { LocationIcon } from '../icons';
import { SearchIcon } from '../icons';
import Autocomplete from '../components/Autocomplete';
import useDevelopmentSearch from '../hooks/useDevelopmentSearch';

const SearchBox = () => {
  const {
    value,
    complete,
    developmentResults,
    predictivePlaceResults,
    loadingLocation,
    geoPosition,
    onPredictiveSearchChange,
    onGetUsersLocation,
    setPlace,
  } = useDevelopmentSearch({});

  return (
    <>
      {value && !complete && (
        <Autocomplete
          value={value}
          complete={complete}
          developmentResults={developmentResults}
          predictivePlaceResults={predictivePlaceResults}
          onGetPlace={setPlace}
        />
      )}
      <form action="/find-your-home" className="search-box">
        <span class="search-box__search-icon">
          <SearchIcon />
        </span>
        <input
          name="text"
          placeholder="Search by postcode or area.."
          className="search-box__input"
          value={value}
          onChange={onPredictiveSearchChange}
        />
        <input name="lat" value={geoPosition.latitude} hidden readOnly />
        <input name="lng" value={geoPosition.longitude} hidden readOnly />
        <input name="distance" value="30" hidden readOnly />
        <input name="locationSearch" value={complete ? 1 : 0} hidden readOnly />
        <span
          className="search-box__geo-location-btn search-box__geo-location-btn--mobile"
          onClick={onGetUsersLocation}
        >
          {' '}
          {loadingLocation ? (
            <ClipLoader size={17} color="#74746D" loading />
          ) : (
            <LocationIcon />
          )}
        </span>
        <a
          href="/find-your-home"
          className="search-box__button search-box__button--mobile button button--gold"
        >
          View All Communities
        </a>

        <div className="search-box__options">
          <span
            className="search-box__geo-location-btn"
            onClick={onGetUsersLocation}
          >
            {' '}
            {loadingLocation ? (
              <ClipLoader size={17} color="#74746D" loading />
            ) : (
              <LocationIcon />
            )}{' '}
            <span>Current Location</span>
          </span>
          <a
            href="/find-your-home"
            className="search-box__button button button--gold"
          >
            View All Communities
          </a>
        </div>
      </form>
    </>
  );
};

export default SearchBox;
